import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

/**
 * The shared bare file picker: owns the raw `<input type="file">` so screen
 * templates carry no raw inputs. The parent keeps the upload logic —
 * `(fileSelected)` re-emits the raw change event (handlers keep reading
 * `$event.target.files`), `(clickEvent)` the raw click (the app's
 * `chooseFileClick($event)` pattern). `clear()` resets the chosen file
 * (replaces the old `#inputFile` nativeElement.value = '' resets).
 */
@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
})
export class FileInputComponent {
  @Input() inputId = '';
  @Input() name: string | null = null;
  @Input() accept: string | null = null;
  /** Title attribute (already-translated string). */
  @Input() title = '';
  /** Extra class(es) on the input, e.g. 'mb-4' or 'd-none'. */
  @Input() cssClass = '';
  @Input() disabled = false;
  /** Invisible full-size overlay picker (image-tile widgets): the input
   *  stretches over the nearest positioned ancestor at opacity 0. */
  @Input() overlay = false;

  /** Raw change event of the file input. */
  @Output() fileSelected = new EventEmitter<Event>();
  /** Raw click event (legacy chooseFileClick handlers). */
  @Output() clickEvent = new EventEmitter<Event>();

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  /** Reset the picker so selecting the same file re-fires change. */
  clear(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  /** Open the native file dialog (replaces the legacy `#ref.click()`). */
  openPicker(): void {
    this.fileInput?.nativeElement.click();
  }
}
